import { authorizedFetch } from "../auth/auth.ts";
import { config } from "../config.ts";

/**
 * Les discussions du lecteur, tous livres confondus (`GET /server/chat/conversation/all` du serveur IA, avec le jeton
 * du compte comme le lecteur et l'app) : pour les lister dans la bibliothèque et trier les livres par derniers chats.
 */
export interface LibraryConversation {
  id: string;
  name?: string | null;
  /** null : la discussion avec le livre ; "character" : avec une personne du livre. */
  kind?: string | null;
  character?: { name: string } | null;
  product_ids: string[];
  book_titles?: string[];
  created_at: string;
  /** Date du dernier message ; null avant le premier. */
  last_message_at?: string | null;
}

export async function fetchConversations(): Promise<LibraryConversation[]> {
  const response = await authorizedFetch(`${config.aiApiUrl.replace(/\/+$/, "")}/server/chat/conversation/all`, {
    headers: { Accept: "application/json", "X-Auth-Provider": "reader-application" },
    cache: "no-store",
  });
  if (!response.ok) throw new Error(`Discussions indisponibles (HTTP ${response.status}).`);
  return (await response.json()) as LibraryConversation[];
}

/** Les discussions commencées (au moins un message), de la plus récente à la plus ancienne. */
export function startedConversations(conversations: LibraryConversation[]): LibraryConversation[] {
  return conversations
    .filter((conversation) => !!conversation.last_message_at)
    .sort((a, b) => Date.parse(b.last_message_at!) - Date.parse(a.last_message_at!));
}

/** Le dernier message échangé sur chaque produit (ms), toutes discussions confondues. */
export function lastChatByProduct(conversations: LibraryConversation[]): Map<string, number> {
  const last = new Map<string, number>();
  for (const conversation of conversations) {
    if (!conversation.last_message_at) continue;
    const at = Date.parse(conversation.last_message_at);
    for (const productId of conversation.product_ids) if (at > (last.get(productId) ?? 0)) last.set(productId, at);
  }
  return last;
}
